import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa';
import { getRealEstatePrograms } from '../data/realEstatePrograms';
import ProjectHeader from '../components/real-estate/ProjectHeader';
import ProjectMain from '../components/real-estate/ProjectMain';
import ProjectSidebar from '../components/real-estate/ProjectSidebar';

const ProjetImmobilierDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const programs = getRealEstatePrograms(t);
    const foundProject = programs.find(p => p.id === parseInt(id));
    setProject(foundProject);
    setLoading(false);
    
    // Mise à jour du titre de la page avec le nom du projet
    if (foundProject) {
      document.title = `${foundProject.title} | SOCABEG`;
    }
  }, [id, t]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-socabeg-blue"></div>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">{t('projectNotFound')}</h2>
          <Link to="/promotion-immobiliere" className="text-socabeg-blue hover:underline">
            <FaArrowLeft className="inline mr-2" /> {t('backToList')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* En-tête avec image principale */}
      <ProjectHeader project={project} t={t} />

      {/* Contenu principal */}
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-col lg:flex-row lg:space-x-8">
          {/* Colonne de gauche - Contenu principal (largeur réduite) */}
          <div className="flex-1 lg:max-w-3xl">
            <ProjectMain project={project} t={t} />
          </div>

          {/* Colonne de droite - Sidebar */}
          <div className="mt-8 lg:mt-0">
            <ProjectSidebar project={project} t={t} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjetImmobilierDetail;
